<template>
  <v-container class="ma-5">


    <squareExp />



    <div>
      <v-btn disable @click="addLearnMoreToAllCards">
        addLearnMoreToAllCards
      </v-btn>

    </div>
    <div>
      <v-btn disabled @click="addIdentifierToAllCards">
        addIdentifierToAllCards
      </v-btn>

    </div>
    <div>
      <v-btn disabled @click="addDomainAuth">
        Add Domain Auth from Email
      </v-btn>
    </div>


    <v-btn disabled @click="addUserData">
      add user data
    </v-btn>

    <v-btn :loading="loading" @click="backUp">Back Up Data</v-btn>

    <v-card v-for="user in users">{{user.name}} {{user.uid}}</v-card>

    <v-btn disabled @click="addEditorFieldToDecks()">
      Add Deck Field
    </v-btn>
    <v-btn @click="unpublishAllDecks()">
      Unpublish
    </v-btn>
  </v-container>
</template>
<script>
import db from '@/fb'
import _ from 'underscore'
import firebase from 'firebase'
import uuid from 'uuid/v4'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid';
import squareExp from '@/components/squareExp'


import OMetrics from '@/OMetrics'

export default {
  name: 'Playground',
  components: {
    squareExp


  },
  mounted() {
    this.usersData()


    var test = OMetrics.createDeckMetrics()
    test.timeAssessSet()
    console.log(test)

  },
  data() {
    return {
      deck: [],
      knowledge: null,
      loading: false,
      users: [],


    };
  },

  methods: {

    //Upgrade Plan
    /*
    Run addLearnMoreToAllCards

    Add Code
    */

    addLearnMoreToAllCards() {


      firebase.firestore().collection('cards').get().then(snapshot => {
        let counter = 0
        let batch = firebase.firestore().batch()
        snapshot.forEach(doc => {
          let ref = firebase.firestore().collection('cards').doc(doc.id)
          batch.update(ref, {learnMore: '', learnMore_image: ''})
          counter += 1
          if (counter > 490) {
            batch.commit().then(() => {
              console.log("batch")
            })
            batch = firebase.firestore().batch()
            counter = 0
          }
        })
      })



    },



    addIdentifierToAllCards() {


      firebase.firestore().collection('cards').get().then(snapshot => {
        let counter = 0
        let batch = db.batch()
        snapshot.forEach(doc => {
          let ref = firebase.firestore().collection('cards').doc(doc.id)
          batch.update(ref, {identifier: uuidv4()})
          counter += 1
          if (counter > 490) {
            batch.commit().then(() => {
              console.log("batch")
            })
            batch = db.batch()
            counter = 0
          }
        })
      })



    },


    addDomainAuth() {
      var batch = db.batch();
      firebase.firestore().collection('decks').get().then(snapshot => {
        snapshot.forEach(doc => {

          let ref = firebase.firestore().collection('decks').doc(doc.id)

          batch.update(ref, {domainAuth: []})


        })
        batch.commit().then(()=>{console.log('done')})

      })
    },


    addUserData() {
      var batch = db.batch();
      firebase.firestore().collection('users').get().then(snapshot => {
        snapshot.forEach(doc => {
          let ref = firebase.firestore().collection('users').doc(doc.id)
          batch.update(ref, {'tos':false, 'subscribedDecks':[]})
        })
        batch.commit().then(()=>{console.log('done')})

      })
    },

    unpublishAllDecks() {
      var batch = db.batch();
      firebase.firestore().collection('decks').get().then(snapshot => {
        snapshot.forEach(doc => {
          let ref = firebase.firestore().collection('decks').doc(doc.id)
          batch.update(ref, {'public':false})
        })
        batch.commit().then(()=>{console.log('done')})

      })
    },

    testFunction() {
      firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid).get().then(result => {
        console.log(result.data())
      })
    },
    backUp() {
      this.loading = true
      let data = {
        authorizationKey: 'ahsdfia98ah3r9823iouunrw8e0hr93brp9qu3nropin',
      }
      let backupData = firebase.functions().httpsCallable('backupData')
      return backupData(data)
      .then(response => {
        this.loading = false
        console.log(response.data)
      })
    },
    usersData() {
      firebase.firestore().collection('users').get().then(snapshot => {
        snapshot.forEach(doc => {
          let result = doc.data()
          result.id = doc.id
          result.name = result.lastname + ', ' + result.firstname
          this.users.push(result)
        })
        this.users = _.sortBy(this.users, 'name')
      })
    },
    addEditorFieldToDecks() {
      var batch = db.batch();
      firebase.firestore().collection('decks').get().then(snapshot => {
        snapshot.forEach(doc => {
          let ref = firebase.firestore().collection('decks').doc(doc.id)
          batch.update(ref, {'editors':[]})
        })
        batch.commit().then(()=>{console.log('done')})

      })
    }

  }

}

</script>
<style>
</style>
